var _style, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgOncomingTrafficOblToYieldCanvas(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Lager_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 80 80",
    height: 80,
    width: 80,
    style: {
      enableBackground: "new 0 0 80 80"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{fill:#FFFFFF;}\r\n\t.st1{fill:#005092;}\r\n\t.st2{fill:#E73137;}\r\n")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(8,8) scale(0.8)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M9.7,5.3h59c1.2,0,2.4,0.5,3.2,1.3c0.9,0.9,1.3,2,1.3,3.2v59c0,1.2-0.5,2.4-1.3,3.2c-0.9,0.9-2,1.3-3.2,1.3h-59 c-1.2,0-2.4-0.5-3.2-1.3c-0.9-0.9-1.3-2-1.3-3.2v-59c0-1.2,0.5-2.4,1.3-3.2C7.3,5.8,8.5,5.3,9.7,5.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M9.7,7.6h59c1.3,0,2.3,1,2.3,2.3v59c0,1.3-1,2.3-2.3,2.3h-59c-1.3,0-2.3-1-2.3-2.3v-59C7.4,8.6,8.4,7.6,9.7,7.6 z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st2",
    points: "30.3,46.8 30.3,18.2 22.2,18.2 22.2,46.8 12.6,46.8 26.3,60.4 39.9,46.8 "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st0",
    points: "53.5,18.2 65.7,30.5 56.2,30.5 56.2,60.4 50.7,60.4 50.7,30.5 41.2,30.5 "
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOncomingTrafficOblToYieldCanvas);
export default __webpack_public_path__ + "static/media/oncoming-traffic-obl-to-yield-canvas.95a40b794262c19769d8b3ee64e4bbe4.svg";
export { ForwardRef as ReactComponent };